import React, { ReactNode } from "react";

import ActionButtons, {
  ActionButtonProps,
} from "../../../../../../../../../components/Generic/ActionButtons";
import LoadingModal from "../../../../../../../../../components/LoadingModal";
import useStyles, { ButtonsContainer } from "./styles";

type Props = {
  children?: ReactNode;
  actionButtonProps?: ActionButtonProps;
  loading?: boolean;
};

const Wrapper = (props: Props) => {
  const { children, actionButtonProps, loading } = props;
  const classes = useStyles();

  return (
    <>
      <div className={classes.preferencesWrapper}>{children}</div>
      <ButtonsContainer container direction="row" alignItems="center" justifyContent="flex-end">
        <ActionButtons {...(actionButtonProps || {})} />
      </ButtonsContainer>
      <LoadingModal showing={loading} />
    </>
  );
};

export default Wrapper;
